import { render, staticRenderFns } from "./term.vue?vue&type=template&id=41980d61&scoped=true&"
var script = {}
import style0 from "../../assets/css/relate.css?vue&type=style&index=0&id=41980d61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41980d61",
  null
  
)

export default component.exports